import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import Avatar from './avatar';
import CoverImage from './cover-image';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import Markdown from 'markdown-to-jsx';
import 'dayjs/locale/fr';
import 'dayjs/locale/en';
import dayjs from 'dayjs';
export default function PostPreview(_ref) {
  var post = _ref.post;
  var lang = true ? window.navigator.language.includes("fr") ? "fr" : "en" : 'en';

  var _useTranslation = useTranslation(),
      i18n = _useTranslation.i18n,
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs("div", {
    className: "px-0 mb-24 xl:px-14",
    children: [/*#__PURE__*/_jsx("div", {
      className: "mb-5",
      children: /*#__PURE__*/_jsx(CoverImage, {
        post: post
      })
    }), /*#__PURE__*/_jsx("h3", {
      className: "mb-3 text-3xl leading-snug",
      children: /*#__PURE__*/_jsx(Link, {
        href: "/blog/".concat(post === null || post === void 0 ? void 0 : post.slug),
        children: /*#__PURE__*/_jsx("a", {
          className: "hover:underline",
          children: post === null || post === void 0 ? void 0 : post.slug
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "py-2 mb-4 text-lg font-semibold text-gray-700",
      children: dayjs(post === null || post === void 0 ? void 0 : post.date_created).locale(lang).format("dddd DD MMMM YYYY")
    }), /*#__PURE__*/_jsx("div", {
      className: "mb-4 text-lg leading-relaxed",
      children: /*#__PURE__*/_jsx(Markdown, {
        children: post.subtitle
      })
    }), /*#__PURE__*/_jsx(Avatar, {
      post: post
    })]
  });
}